/**
 * A `noindex` wall display, so no `sitemap` export; on `www` because the screens hold that URL
 * (TEC-3770). One slug in every locale since the copy is hardcoded English (TEC-2226 added four
 * translated ones nobody opened), but each locale still needs an entry to get its prefix.
 */
export const routeName = 'live-counter';
export const slugs: Record<string, string> = {
	en: 'live-counter',
	es: 'live-counter',
	ca: 'live-counter',
	fr: 'live-counter',
	it: 'live-counter',
};
